export const faqState = [
  {value: 0, text: "未対応"},
  {value: 1, text: "対応中"},
  {value: 2, text: "完了"},
]